module.exports = __webpack_public_path__ + "img/meats.0eba3562.jpg";